import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReorderComponent} from './reorder.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ReorderComponent],
  exports: [ReorderComponent],
})
export class ReorderModule {}
